import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadPosts () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.pagination.getParams(),
    })

    api.get('posts', { params })
      .then(result => {
        this.posts = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  askDelete (postId) {
    this.showDeleteDialog = true
    this.deletingId = postId
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Publicação excluída')
          this.loadPosts()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir publicação')
        this.loadPosts()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
